export default __webpack_public_path__ + "static/media/Snd_ClowerF.11a2b293.mp3";